import action from "../../decorators/action.decorator";
import reducer, { InitSchemaReducer } from "../../decorators/reducer.decorator";
import { DIContainerKeys } from "../../di-container/di-container.keys";
import { Entities } from "../../store/entities/entities.enum";
import { HttpService } from "../http.service";
import loader from "../../decorators/loader.decorator";
import { Loaders } from "../../store/loaders/loaders.enum";
import flagger from "../../decorators/flagger.decorator";
import { Flaggers } from "../../store/flaggers/flaggers.enum";
import type ExtendTrialDto from "./dto/extend-trial.dto";

export const SubscriptionEffectActions = {
  extendTrial: `${Entities.Subscription}_extendTrial`,
};

const initSchema: InitSchemaReducer = {
  definitions: {},
  options: { idAttribute: "" },
};

@reducer({
  entityName: Entities.Subscription,
  initSchema,
  aliasName: DIContainerKeys.SubscriptionService,
})
export class SubscriptionService extends HttpService {
  @loader(Loaders.ExtendTrialLoader)
  @flagger(Flaggers.ExtendTrialModalFlagger)
  @action(DIContainerKeys.SubscriptionService)
  public *extendTrial(dto: ExtendTrialDto): Generator<any, void, any> {
   
  }

  @loader(Loaders.ConvertSubscriptionLoader)
  @flagger(Flaggers.ConvertSubscriptionModalFlagger)
  @action(DIContainerKeys.SubscriptionService)
  public *convertSubscription(): Generator<any, void, any> {
    
  }
}
